"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/AccordionComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AccordionItem_1 = __importDefault(require("../AccordionComponent/AccordionItem"));
var AccordionComponent = /** @class */ (function (_super) {
    __extends(AccordionComponent, _super);
    function AccordionComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "pb-40" },
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.Description } }),
            react_1.default.createElement("div", { id: "accordion_" + this.props.UniqueKey, className: "accordion theme-1" }, this.props.Items.map(function (item, i) {
                return react_1.default.createElement(AccordionItem_1.default, { key: item.UniqueKey, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Title: item.Title, Content: item.Content });
            }))));
    };
    return AccordionComponent;
}(react_1.default.Component));
exports.default = AccordionComponent;
